import React, { useContext } from 'react';

import LoginContext from 'context/LoginContext';
import Login from 'pages/Login';

interface PrivateRouteProps {
	children: any;
	redirectTo: string;
}

export default function PrivateRoute({
	children // componente que é passado dentro do PrivateRoute
}: PrivateRouteProps) {
	const { isLogged } = useContext(LoginContext);

	return isLogged ? children : <Login />;
}
